import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Loading from '../../components/Loading/Loading';

const MsLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');

  useEffect(() => {
    const loginWithMs = async () => {
      if (!code) return;

      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}Account/LoginMs`, {
          code
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        const result = response.data;

        if (result?.data?.token?.accessToken) {
          localStorage.setItem('token', result?.data?.token.accessToken);
          navigate('/');
        } else {
          navigate('/login');
        }
      } catch (error) {
        navigate('/login');
      }
    };

    loginWithMs();
  }, [code, navigate]);

  return <Loading />;
};

export default MsLogin;